<template>
  <div class="vacancies">
    <widget-link
      v-for="vacancy in vacanciesList"
      :key="vacancy.id"
      :item="vacancy"
      @closeMenu="$emit('closeMenu')"
    ></widget-link>
  </div>
</template>

<script>
import WidgetLink from '~/components/menu/WidgetLink'

const vacanciesUrl = 'https://api.hh.ru/vacancies?employer_id=633069&per_page=3&employment=full&employment=part'
const probationUrl = 'https://api.hh.ru/vacancies?employer_id=633069&per_page=3&employment=probation'

export default {
  name: 'Vacancies',
  components: {WidgetLink},
  props: {
    mode: {
      type: String,
      default: ''
    }
  },
  async fetch() {
    [this.vacancies, this.internships] = await Promise.all([
      await fetch(this.vacanciesUrl).then(res => res.json()),
      await fetch(this.probationUrl).then(res => res.json())
    ])
  },
  fetchOnServer: false,
  data() {
    return {
      vacanciesUrl,
      probationUrl,
      vacancies: {},
      internships: {}
    }
  },
  computed: {
    currentList() {
      if (this.mode === 'vacancies') {
        return this.vacancies
      } else {
        return this.internships
      }
    },
    vacanciesList() {
      if (this.currentList.items && this.currentList.items.length > 0) {
        const vacanciesList = []

        this.currentList.items.forEach(vacancy => {
          vacanciesList.push({
            title: vacancy.name,
            externalTypeOfLink: true,
            url: {
              // TODO
              // path: `/careers/all/vacancy/${vacancy.id}/`,
              path: vacancy.alternate_url,
              hash: null
            },
            labels: [
              {
                iconName: 'marker',
                name: this.checkVacancyHasCity(vacancy)
              }
            ],
            description: null
          })
        })

        return vacanciesList
      }

      return {}
    }
  },
  methods: {
    checkVacancyHasCity(vacancy) {
      if (vacancy.address && vacancy.address.city) {
        return vacancy.address.city
      } else {
        return vacancy.area && vacancy.area.name
          ? vacancy.area.name
          : 'город не указан'
      }
    }
  }
}
</script>